import * as styles from "./TemplatePageNotFound.css";
import { Heading } from "../elements/Heading";
import { Paragraph } from "../elements/Paragraph";
import { ButtonLink } from "../elements/ButtonLink";
// @ts-ignore
import ArrowLeft from "@material-design-icons/svg/filled/arrow_back.svg?react";
import Grid from "../globals/Grid";
export interface ITemplatePageNotFound {
  data: any;
}

export default function TemplatePageNotFound({ data }: ITemplatePageNotFound) {
  // console.log("templatePageNotFound", data);
  const { title, text, link } = data;
  return (
    <section className={styles.section}>
      <Grid>
        <div className={styles.grid}>
          <div className={styles.container}>
            <div className={styles.content}>
              {title && (
                <Heading as="h1" size="xl" className={styles.heading}>
                  {title}
                </Heading>
              )}
              {text && <Paragraph>{text}</Paragraph>}
            </div>
            {link && link.slug && (
              <ButtonLink
                link={link}
                theme="light"
                layout="inverse"
                icons={{ iconPrimary: <ArrowLeft /> }}
              >
                {link.text}
              </ButtonLink>
            )}
          </div>
        </div>
      </Grid>
    </section>
  );
}
